/**
 * The final-decision API exposes raw vote values (`YES` | `NEUTRAL` | `NO`), unlike the
 * secondary-vote store which rewrites them to `GO` / `NOGO` / `INDIFFERENT` on the way in. Mapping
 * at the display edge keeps the shared tone/label helpers working without altering what we send.
 */
const DISPLAY_VOTE_BY_RAW_VOTE = Object.freeze({
  YES: 'GO',
  NO: 'NOGO',
  NEUTRAL: 'INDIFFERENT',
});

/** `VOTE` covers both "recorded" and "changed"; `DELETE` is the decision being withdrawn. */
export const FINAL_DECISION_EVENT = Object.freeze({
  VOTE: 'VOTE',
  DELETE: 'DELETE',
});

/**
 * The API error codes this feature acts on rather than merely displays; they must match the API's
 * enum exactly. Every other code is rendered from its `error.code.*` i18n key, which is the registry
 * of what the API can return.
 */
export const SECONDARY_VOTES_LOCKED = 'SECONDARY_VOTES_LOCKED';
export const FINAL_DECISION_ALREADY_EXISTS = 'FINAL_DECISION_ALREADY_EXISTS';
export const FINAL_DECISION_NOT_FOUND = 'FINAL_DECISION_NOT_FOUND';

export function toFinalDecisionDisplayVote(vote) {
  return DISPLAY_VOTE_BY_RAW_VOTE[vote] ?? null;
}

/** Gate edit/delete on this, not on the permission alone — anyone else gets a 403. */
export function isFinalDecisionOwner(finalDecision, user) {
  return !!finalDecision && !!user && finalDecision.decidedBy === user.id;
}
